import { render, staticRenderFns } from "./info-offer-past-interest.vue?vue&type=template&id=124f47ec&scoped=true&"
var script = {}
import style0 from "./info-offer-past-interest.vue?vue&type=style&index=0&id=124f47ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f47ec",
  null
  
)

export default component.exports